// src/pages/NotFoundPage.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-blue-600 mb-4">404</h1>
        <h2 className="text-3xl font-semibold mb-6">Page Not Found</h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
          Check the URL or navigate back to our homepage.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-300"
        >
          Return to Home
        </Link>
      </div>
      
      <div className="mt-12 border-t border-gray-200 pt-8 w-full max-w-md">
        <h3 className="text-lg font-medium text-gray-700 mb-4">You might be looking for:</h3>
        <ul className="space-y-2">
          <li>
            <Link to="/features" className="text-blue-600 hover:underline">
              Features
            </Link>
          </li>
          <li>
            <Link to="/pricing" className="text-blue-600 hover:underline">
              Pricing Plans
            </Link>
          </li>
          <li>
            <Link to="/contact" className="text-blue-600 hover:underline">
              Contact Support
            </Link>
          </li>
          <li>
            <Link to="/login" className="text-blue-600 hover:underline">
              Log In
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NotFoundPage;
